<template>
    <div v-if="adsEnabled">
      <ins class="adsbygoogle"
           style="display:block"
           data-ad-client="ca-pub-4529948013175961"
           data-ad-slot="6969906486" 
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
    </div>
  </template>
  
  <script>
  export default {
    name: "GoogleAd",
    data() {
      return {
        adsEnabled: true, // Set to false for premium users or ad-free plans
      };
    },
    mounted() {
      this.loadGoogleAds();
    },
    methods: {
      loadGoogleAds() {
        if (typeof window === "undefined") return; // Ensure it's running on client side
  
        if (!window.adsbygoogle) {
          // Inject Google Ads script dynamically if not already loaded
          const script = document.createElement("script");
          script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7683987116036287";
          script.async = true;
          script.crossOrigin = "anonymous";
          script.onload = () => {
            this.pushAd();
          };
          document.head.appendChild(script);
        } else {
          this.pushAd();
        }
      },
      pushAd() {
        if (window.adsbygoogle) {
          try {
            window.adsbygoogle.push({});
          } catch (e) {
            console.error("Google Ads failed to load:", e);
          }
        }
      }
    }
  };
  </script>
  